<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入话题id" v-model="params.id" clearable size="small" class="param-input"></el-input>
      <el-input placeholder="请输入话题名称" v-model="params.sectionName" clearable size="small" class="param-input"></el-input>
      <el-select v-model="params.zone" placeholder="请选择专区" clearable size="small">
        <el-option
          v-for="item in zones"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="params.active" placeholder="请选择是否启用" clearable size="small">
        <el-option
          v-for="item in enables"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="getSections('status')" style="margin-right: 20px">搜索</el-button>
      <el-button type="primary" size="small" @click="addAndEdit('add')" style="margin-right: 20px">新增</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" ref="multipleTable" height="600">
      <el-table-column prop="id" label="话题id" align="center" fixed min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="话题名称" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.name || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cover"
        label="话题封面"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.img"
            :width="'180px'"
            :height="'90px'"
            v-if="scope.row.img"
          />
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column prop="active" label="状态" align="center" min-width="120">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.active">启用</el-tag>
          <el-tag type="danger" v-if="!scope.row.active">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="inList" label="是否专题列表" align="center" min-width="120">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.inList">是</el-tag>
          <el-tag type="danger" v-if="!scope.row.inList">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="zone" label="专区" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.zone || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sortNum" label="排序" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.sortNum || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ initTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ initTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="280" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button size="mini" type="warning" icon="el-icon-view" @click="watchClickNum(scope.row)">点击量</el-button> -->
          <el-button size="mini" type="success" icon="el-icon-edit" @click="addAndEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" background 
      @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @before-close="handleClose">
      <el-form :model="form" label-width="120px" :rules="rules" ref="form">
        <el-form-item class="imgItem" label="封面上传:" prop="img">
          <base-upload
            :cover="form.img"
            :action="action"
            @successCallback="successCallback"
            :id="form.sourceID"
            :hide="true"
          ></base-upload>
        </el-form-item>
        <el-form-item label="话题名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="专区">
          <el-select v-model="form.zone" placeholder="请选择专区">
            <el-option
              v-for="item in zones"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select v-model="form.active" placeholder="请选择是否启用">
            <el-option
              v-for="item in enables"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排版">
          <el-select v-model="form.direction" placeholder="请选择排版">
            <el-option
              v-for="item in directions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sortNum">
          <el-input v-model.number="form.sortNum"></el-input>
        </el-form-item>
        <el-form-item label="是否专题列表:" prop="inList">
          <el-switch v-model="form.inList"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="点击量" :visible.sync="isClickNum" class="clickNumDialog" :close="close">
      <!-- <el-date-picker v-model="clickNumTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker> -->
      <el-button type="primary" size="small" icon="el-icon-search" @click="queryClickNum()">搜索</el-button>
      <el-table :data="clickNumList" max-height="600" border style="width: 100%; margin-top: 20px;" v-loading="clickLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <el-table-column prop="date" label="日期" min-width="180" align="center"></el-table-column>
        <el-table-column prop="sectionID" label="话题ID" min-width="180" align="center"></el-table-column>
        <el-table-column prop="hitsPerDay" label="点击量" min-width="180" align="center"></el-table-column>
      </el-table>
      <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="clickNumParams.pageNumber" :page-size="clickNumParams.pageSize"
      layout=" sizes, prev, pager, next, jumper" :total="clickNumParams.total" background 
      @size-change="changeDialogSize" @current-change="changeDialogCurrent"></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api';
import { changeTime } from "@/utils/global";
import { uniteDate } from '@/utils/validator.js'
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      enables: [
        { label: '启用', value: true },
        { label: '禁用', value: false },
      ],
      directions: [
        { label: '竖版3', value: 0 },
        { label: '竖版6', value: 1 },
        { label: '竖版4', value: 2 },
        { label: '横版4', value: 3 },
        { label: '横版5(1大4小)', value: 4 },
        { label: '横版6', value: 5 },
      ],
      zones: [
        { label: '最新', value: '最新' },
        { label: '精选', value: '精选' },
        { label: '动漫', value: '动漫' },
        { label: '漫画', value: '漫画' },
        { label: 'COS', value: 'COS' },
        { label: '真人', value: '真人' },
        { label: '小说', value: '小说' },
        { label: '写真', value: '写真' },
        { label: '原作', value: '原作' },
      ],
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 30,
        sort: [
          {
            sortKey: 'sort',
            sortVal: -1
          }
        ]
      },
      form: {
        name: '',
        desc: '',
        zone: '',
        direction: undefined,
        sortNum: undefined,
        active: undefined,
        inList: false,
        img: undefined,
      },
      dialogVisible: false,
      dialogTitle: '',
      rules: {
        name: [
          { required: true, message: '请输入话题名称', trigger: 'blur' }
        ],
        zone: [
          { required: true, message: '请选择专区', trigger: 'blur' }
        ],
        active: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ],
      },
      isClickNum: false,
      clickNumTime: '',
      clickNumParams: {
        pageNumber:1,
        pageSize: 10,
        sectionID: '',
        // total: 0,
        start: '',
        end: '',
      },
      clickNumList: [],
      clickLoading: false,
    };
  },
  created() {
    this.getSections();
  },
  methods: {
    // 封面图上传成功回调
    successCallback(res) {
      this.form.img = res.data.coverImg;
      // this.form.coverThumb = res.data.coverImg;
    },
    // 请求列表
    getSections(type) {
      this.loading = false;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getDmSections(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增话题配置
    addAndEdit(param) {
      this.dialogVisible = true;  // 打开新增、编辑对话框
      if(param === 'add') {
        this.dialogTitle = '新增'
      } else {
        this.dialogTitle = '编辑'
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.name = param.name;
        this.form.desc = param.desc;
        this.form.zone = param.zone;
        this.form.direction = param.direction;
        this.form.sortNum = param.sortNum;
        this.form.active = param.active;
        this.form.inList = param.inList;
        this.form.img = param.img;
      }
    },
    // 新增、修改提交
    onSubmit() {
      if(this.dialogTitle === '新增') {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const addData = {
            name: this.form.name,
            desc: this.form.desc,
            zone: this.form.zone,
            direction: this.form.direction,
            sortNum: this.form.sortNum,
            soactivertNum: this.form.active,
            img: this.form.img,
            inList: this.form.inList,
          }
          API.addDmSection(addData)
            .then((res) => {
              if(res.code === 200) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.dialogVisible = false;
                this.getSections();
              } else {
                this.$message({
                  type: 'error',
                  message: '新增失败'
                })
              }
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '服务器异常'
              })
            })
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          API.editDmSection(this.form)
            .then((res) => {
              if(res.code === 200) {
                this.$message({
                  type: 'success',
                  message: '编辑成功'
                })
                this.dialogVisible = false;
                this.getSections();
              } else {
                this.$message({
                  type: 'error',
                  message: '编辑失败'
                })
              }
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '服务器异常'
              })
            })
        } else {
          return false;
        }
      });
    },
    // 删除方法
    del(param) {
      this.$confirm(`确认是否删除<span style='color: blue'>${param.name}</span>, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        let delData = {
          id: param.id
        }
        API.deleteDmSection(delData).then((res) => {
          if(res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'success',
              message: '删除失败!'
            });
          }
          this.getSections();
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '服务器异常!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    // 打开点击量弹窗
    watchClickNum(row) {
      this.clickNumParams.sectionID = row.id;
      this.queryClickNum();
      this.isClickNum = true;
    },
    // 查询点击量
    queryClickNum() {
      let req = {
        pageNumber: this.clickNumParams.pageNumber,
        pageSize: this.clickNumParams.pageSize,
        sectionID: this.clickNumParams.sectionID,
        // start: this.clickNumParams.start ? this.clickNumParams.start : undefined,
        // end: this.clickNumParams.end ? this.clickNumParams.end : undefined,
      }
      this.clickLoading = true;
      API.queryClicks(req)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.clickNumList = res.data.List ? res.data.List : [];
            // this.clickNumParams.total = res.data.total ? res.data.total : 0;
          } else {
            this.clickNumList = [];
          }
          this.clickLoading = false;
        })
        .catch(() => {
          this.clickLoading = false;
        });
    },
    // 关闭点击量弹窗
    close() {
      this.clickNumTime = '';
      this.clickNumParams.pageNumber = 1;
      this.clickNumParams.pageSize = 10;
      // this.clickNumParams.total = 0;
      this.clickNumParams.sectionID = '';
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.name = '';
      this.form.zone = undefined;
      this.form.active = 1;
      this.form.sortNum = undefined;
      this.form.inList = false,
      this.form.img = undefined
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getSections();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getSections();
    },
    // 分页条数改变回调
    changeDialogSize(size) {
      this.clickNumParams.pageSize = size;
      this.queryClickNum();
    },
    // 分页页码改变回调
    changeDialogCurrent(pageNumber) {
      this.clickNumParams.pageNumber = pageNumber;
      this.queryClickNum();
    },
    // 更换时间格式
    initTime(time) {
      return uniteDate(time);
    },
    // 时间变化
    changeTime(time) {
      if (time) {
        this.clickNumParams.start = changeTime(time[0])
        this.clickNumParams.end = changeTime(time[1])
      } else {
        this.clickNumParams.start = ''
        this.clickNumParams.end = ''
      }
      this.queryClickNum()
    }
  },
};
</script>

<style lang="scss" scoped>
  .dialog-footer {
    position: relative;
    left: 50%;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
  }
  /deep/ .el-form-item {
    display: flex;
  }
  /deep/ .el-form-item__content {
    flex: 2;
  }
  /deep/ .el-select {
    width: 100%;
  }
  .clickNumDialog {
    /deep/ .el-dialog__body {
      padding-top: 10px;
    }
    /deep/ .el-pagination {
      float: none;
      text-align: right;
      margin-top: 30px;
    }
  }
</style>
